import { render, staticRenderFns } from "./CommitteeMembers.vue?vue&type=template&id=0d800a52&"
import script from "./CommitteeMembers.vue?vue&type=script&lang=js&"
export * from "./CommitteeMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports